export default __webpack_public_path__ + "media/rm_l.4c1a74d2.mov";